export var AspectRatio;
(function (AspectRatio) {
    AspectRatio["A4_3"] = "4:3";
    AspectRatio["A16_9"] = "16:9";
    AspectRatio["A3_4"] = "3:4";
})(AspectRatio || (AspectRatio = {}));
